import PropTypes from 'prop-types';
import styles from './input.module.scss';
import { borderError, buildCurrencyFormat, isNum } from '../../core/helper';
import { useState } from 'react';

export const QuantityRange = ({
    name,
    inputAlign = 'left',
    label,
    value,
    onChange,
    onBlur,
    disabled = false,
    currencyFormat,
    currencySymbol = '',
    error
}) => {

    const [focused, setFocused] = useState();

    const onInputType = ({ target }) => {
        const name = target.name;
        const inputValue = target.value;
        if( inputValue !== '' && isNum(inputValue) && ( inputValue >= 0 && inputValue <= 999999999 ) ) {
            onChange(name, inputValue)
        } else if( inputValue === '' ) {
            onChange(name, '')
        }
    }

    const buildStyle = () => ({
        width: '100%',
        textAlign: inputAlign
    })

    return (
        <div className={ styles.error_container }>
            <div className={ styles.error_container_range_line }>
                { label && label.range1 }
                <input
                    name={ name.range1 }
                    autoComplete='off'
                    style={{ ...buildStyle(), ...borderError(error) }}
                    placeholder='0.00'
                    onChange={ onInputType }
                    onFocus={ () => setFocused(name.range1) }
                    onBlur={ () => { setFocused(null); onBlur && onBlur(name.range1, value.range1); } }
                    value={ currencyFormat && focused !== name.range1 ? `${currencySymbol}${buildCurrencyFormat(value.range1)}` : value.range1 }
                />
                { label && label.range2 }
                { name.range2 && (
                    <input
                        name={ name.range2 }
                        autoComplete='off'
                        style={{ ...buildStyle(), ...borderError(error) }}
                        placeholder='0.00'
                        onChange={ onInputType }
                        onFocus={ () => setFocused(name.range2) }
                        onBlur={ () => { setFocused(null); onBlur && onBlur(name.range2, value.range2); } }
                        value={ currencyFormat && focused !== name.range2 ? `${currencySymbol}${buildCurrencyFormat(value.range2)}` : value.range2 }
                    />
                )}
            </div>
            { error && (<p className={ styles.error_message_font }>{ error }</p>) }
        </div>
    )
}

QuantityRange.propTypes = {
    name: PropTypes.shape({
		range1: PropTypes.string,
		range2: PropTypes.string,
	}),
    inputAlign: PropTypes.string,
    label: PropTypes.shape({
		range1: PropTypes.string,
		range2: PropTypes.string,
	}),
    value: PropTypes.shape({
		range1: PropTypes.string,
		range2: PropTypes.string,
	}),
    diabled: PropTypes.bool
};